
import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Species } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Species/PathItems';
import AISuggestions from '../../components/AISuggestions';
import { Session } from '../../peer-colab-model/Session';
import { SpeciesManagement } from '../../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';
import Box from '@mui/material/Box';

interface EditSpeciesToolbarProps {
  species: Species;
  breedId?: string;
  onSpeciesClick?: () => void;
  onDataChanged: () => void;
  onBack?: () => void;
}

function EditSpeciesToolbar({ species, breedId, onSpeciesClick, onDataChanged, onBack }: EditSpeciesToolbarProps) {
  const breed = species.breeds.find(b => b.breed.id === breedId)?.breed;

  return (
    <AppBar position="static" color="default" elevation={1} sx={{ p:0, m: 0 }}>
      <Toolbar>
        {onBack && (
          <IconButton edge="start" color="inherit" onClick={onBack} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            underline={onSpeciesClick ? 'hover' : 'none'}
            color="inherit"
            onClick={onSpeciesClick}
            sx={{ cursor: onSpeciesClick ? 'pointer' : 'default' }}
          >
            <Typography variant="h5" component="span">{species.name}</Typography>
          </Link>
          {breed?.name && (
            <Typography variant="h5" component="span" color="text.primary">{breed?.name}</Typography>
          )}
        </Breadcrumbs>
        <Box sx={{ marginLeft: 'auto', width: '80%' }}>
          <AISuggestions 
            client={Session.getClient()}
            currentSnapshot={JSON.stringify(species) + (breed ? '\n\nSpesific breed: ' + JSON.stringify(breed) : '')}
            usageInstructions={SpeciesManagement.toAgentInstructions()}
            developerMessage={'The user is in the view where Are editing a species and potentially a spesific if specified. For any of the operations ' +
              'regarding a specific species the path parameter with the name speciesId MUST be specified with that species id. For '+
              'breeds the path parameter breedId MUST also be specified with that breed id.'}
            onOperationsApplied={() => onDataChanged()}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default EditSpeciesToolbar;
